import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import imgs from "../../imgs/imgsArray";
import "./Carousel.css";
import Hisn from "../HisnHasin/Hisn";
import Music from "../Music/Music";
import tracksArray_alsodais from "../Music/mySongs/tracksArray_alsodais/tracksArray";
import tracksArray_IslamSobhi from "../Music/mySongs/tracksArray_IslamSobhi/tracksArray";
import tracksArray_abid_albaset from "../Music/mySongs/tracksArray_abid_albaset/tracksArray";
import "../Music/music.css";
import DlaylAlkhayrat from "../DlaylAlkhayrat/DlaylAlkhayrat";
// const Quran1Pdf = require("../../../public/assets/pdfs/Quran1");
const islamImg = require("../../imgs/islam.jpg");
const alsodaisImg = require("../../imgs/alsodais.jpg");
const abid_albasetImg = require("../../imgs/abid_albaset.jpg");

export default function Carousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
  };

  return (
    <div className="CarouselContainer">
      <div className="SliderImgs">
        <img className="imgy" src={imgs[2]} alt={imgs[2]} key={0} />
      </div>

      <div>
        {/* <iframe
          src=""
          // src="https://docs.google.com/document/d/e/2PACX-1vT76BRO29hMZYh7xpCuU8Sup6zIk04EeNria7yEB5C-ng1KHMHWGvp5DIF0lc2fv83YPXS63pgNKOfo/pub"
          style={{ width: "100%", height: "600px" }}
          frameBorder="0"
        /> */}
      </div>

      <Slider className="Slider" {...settings}>
        <div className="eachSlider">
          <Music arr={tracksArray_alsodais} imgLink={alsodaisImg} />
        </div>
        <div className="eachSlider">
          <Music arr={tracksArray_IslamSobhi} imgLink={islamImg} />
        </div>
        <div className="eachSlider">
          <Music arr={tracksArray_abid_albaset} imgLink={abid_albasetImg} />
        </div>
        <div className="eachSlider">
          <iframe
            className="Iframe"
            src="https://app.quranflash.com/book/Douri?ar#/reader"
            style={{ border: "none" }}
          ></iframe>
        </div>

        <div className="DlaylAlkhayrat_container">
          <DlaylAlkhayrat />
        </div>

        <div className="eachSlider">
          <Hisn />
          {/* <div className="text_hisn">
            <div>
              <div>
                <h1>حِصْنٌ عَظِيمٌ جداً</h1>
                <h2>حِرْز مَانِعٌ وَتَحْصِين قُوَى </h2>
                <hr />
                <p>
                  يَقْرَأَ قَبْلَ الْقِيَامِ بِأَىّ عَمِل ولِمَنْع الْإِنْسَانِ
                  مِنْ شَرِّ جَمِيعِ الْخَلْقِ ، والأبالسه خَاصَّةً وَهُوَ ;
                  بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ بِسْمِ اللَّهِ ياهوَ
                  بِسْمِ اللَّهِ ياهوَ{" "}
                </p>
                <p>
                  {" "}
                  بِسْمِ اللَّهِ مَجْرَى السِّحْر هُوَ اللَّهُ يَا مَنْ
                  أَلْجَمْت كُلِّ مُتَمَرِّدٍ سَلِّمْ سَلِّمْ ۩{" "}
                </p>
                <p>
                  {" "}
                  يَا اللَّهُ ذَنْبٌ لَا ذَنْبِى أَصْبَحُوا الْبَعِيد عَنَّا ،
                  وَالْقَرِيبَ لَا يُؤْذِينَا ۩{" "}
                </p>
                <p>
                  {" "}
                  اللَّهُمَّ يَا سَابِل السَّتْر إذَا أَحَاطَت بنا الْبَلَاء ،
                  وياسامع الْأَصْوَات مِنْ تَحْتِ العَلَاَ بِحَقّ نَبِيِّك
                  الْمَحْبُوب ، وكرسيك الْمَنْصُوب أَن تَطْمَئِنّ قَلْب عَبْدَك
                  الْخَائِف المرعوب مِن السُّيُوف إذَا سُلت ، وَمَن قُلُوب
                  الْأَعْدَاء إذَا صَدت أَو اسْوَدَّت فَإِن جارو عَلَيْنَا
                  فَرَدّهُم فَأَنْت رَبِّى ، وَرَبّ الْخَلَائِقَ كُلَّهُمْ
                  دُسْتُور دُسْتُور ۩{" "}
                </p>
                <p>بِسْمِ اللَّهِ #سُؤْر ۩ </p>
                <p>
                  {" "}
                  ۞ اللَّهُ نُورُ السَّمَاوَاتِ وَالْأَرْضِ ۚ مَثَلُ نُورِهِ
                  كَمِشْكَاةٍ فِيهَا مِصْبَاحٌ ۖ الْمِصْبَاحُ فِي زُجَاجَةٍ ۖ
                  الزُّجَاجَةُ كَأَنَّهَا كَوْكَبٌ دُرِّيٌّ يُوقَدُ مِن شَجَرَةٍ
                  مُّبَارَكَةٍ زَيْتُونَةٍ لَّا شَرْقِيَّةٍ وَلَا غَرْبِيَّةٍ
                  يَكَادُ زَيْتُهَا يُضِيءُ وَلَوْ لَمْ تَمْسَسْهُ نَارٌ ۚ
                  نُّورٌ عَلَىٰ نُورٍ ۗ يَهْدِي اللَّهُ لِنُورِهِ مَن يَشَاءُ ۚ
                  وَيَضْرِبُ اللَّهُ الْأَمْثَالَ لِلنَّاسِ ۗ وَاللَّهُ بِكُلِّ
                  شَيْءٍ عَلِيمٌ ۩{" "}
                </p>
                <p>وَآيَة الكرسى عَلَيْنَا تَدُور ۩ </p>
                <p>
                  {" "}
                  بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ اللَّهُ لَا إِلَٰهَ
                  إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا
                  نَوْمٌ ۚ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَن
                  ذَا الَّذِي يَشْفَعُ عِندَهُ إِلَّا بِإِذْنِهِ ۚ يَعْلَمُ مَا
                  بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ
                  بِشَيْءٍ مِّنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ وَسِعَ
                  كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ
                  حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ ۩{" "}
                </p>
                <p>
                  {" "}
                  ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ ۩{" "}
                </p>
                <p>
                  ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
                  كَمَا دَار السُّؤْرُ عَلَى مَدِينَةِ الرَّسُولِ لَيْسَ لَهَا
                  #قَفَل ، وَلَا #مِفْتَاح مِن الْمَسَاء حَتَّي الصَّبَّاح
                  اللَّهُ أَكْبَرُ ۩{" "}
                </p>
                <p> اللَّهُ أَكْبَرُ ۩ </p>
                <p> اللَّهُ أَكْبَرُ ۩ </p>
                <p>
                  {" "}
                  عَلَى مَنْ طَغَى ، وَتُجْبَر بِسْمِ اللَّهِ ، وبأسمى وَلِلَّه
                  جسمى ۩{" "}
                </p>
                <p>
                  {" "}
                  رَبَّنَا أحرصنى مِنْ طَوَارِقِ ، وَشَرّ الْجِنّ ، وَالْإِنْس ،
                  وَالشَّيَاطِين ، وَالْوَحْش ، وَالْهَوَامّ ، والديب ،
                  وَالْحَيَوَان ، وَكُلُّ مَا أَخَافُ ، وَاحْذَر لَا يَمَسُّ
                  جسدى سِلَاح ، وَلَا جَرْح ، وَلَا شَيْطَانٌ لَهُ عِنْدَنَا
                  #مِفْتَاح مِفْتَاحَهَا الْبَقَرَة بِسْمِ اللَّهِ الرَّحْمَنِ
                  الرَّحِيمِ أَلَم ۩{" "}
                </p>
                <p>
                  {" "}
                  ذَٰلِكَ الْكِتَابُ لَا رَيْبَ ۛ فِيهِ ۛ هُدًى لِّلْمُتَّقِينَ
                  ۩{" "}
                </p>
                <p>
                  {" "}
                  الَّذِينَ يُؤْمِنُونَ بِالْغَيْبِ وَيُقِيمُونَ الصَّلَاةَ
                  وَمِمَّا رَزَقْنَاهُمْ يُنفِقُونَ ۩{" "}
                </p>
                <p>
                  وَالَّذِينَ يُؤْمِنُونَ بِمَا أُنزِلَ إِلَيْكَ وَمَا أُنزِلَ
                  مِن قَبْلِكَ وَبِالْآخِرَةِ هُمْ يُوقِنُونَ ۩{" "}
                </p>
                <p>
                  {" "}
                  أُولَٰئِكَ عَلَىٰ هُدًى مِّن رَّبِّهِمْ ۖ وَأُولَٰئِكَ هُمُ
                  الْمُفْلِحُونَ ۩{" "}
                </p>
                <p>
                  {" "}
                  وَحِيطَانِهَا بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ يس ۩{" "}
                </p>
                <p> وَالْقُرْآنِ الْحَكِيمِ ۩ </p>
                <p> إِنَّكَ لَمِنَ الْمُرْسَلِينَ ۩ </p>
                <p> عَلَى صِرَاطٍ مُسْتَقِيمٍ ۩ </p>
                <p> تَنْزِيلَ الْعَزِيزِ الرَّحِيمِ ۩ </p>
                <p>
                  {" "}
                  لِتُنْذِرَ قَوْمًا مَا أُنْذِرَ آبَاؤُهُمْ فَهُمْ غَافِلُونَ ۩{" "}
                </p>
                <p>
                  {" "}
                  لَقَدْ حَقَّ الْقَوْلُ عَلَى أَكْثَرِهِمْ فَهُمْ لَا
                  يُؤْمِنُونَ ۩{" "}
                </p>

                <p>
                  {" "}
                  إِنَّا جَعَلْنَا فِي أَعْنَاقِهِمْ أَغْلَالًا فَهِيَ إِلَى
                  الْأَذْقَانِ فَهُمْ مُقْمَحُونَ ۩{" "}
                </p>
                <p>
                  {" "}
                  وَجَعَلْنَا مِنْ بَيْنِ أَيْدِيهِمْ سَدًّا وَمِنْ خَلْفِهِمْ
                  سَدًّا فَأَغْشَيْنَاهُمْ فَهُمْ لَا يُبْصِرُونَ ۩{" "}
                </p>
                <p>
                  {" "}
                  وَسَوَاءٌ عَلَيْهِمْ أَأَنْذَرْتَهُمْ أَمْ لَمْ تُنْذِرْهُمْ
                  لَا يُؤْمِنُونَ ۩{" "}
                </p>
                <p>
                  {" "}
                  إِنَّمَا تُنْذِرُ مَنِ اتَّبَعَ الذِّكْرَ وَخَشِيَ الرَّحْمَنَ
                  بِالْغَيْبِ فَبَشِّرْهُ بِمَغْفِرَةٍ وَأَجْرٍ كَرِيمٍ ۩{" "}
                </p>
                <p>
                  {" "}
                  إِنَّا نَحْنُ نُحْيِي الْمَوْتَى وَنَكْتُبُ مَا قَدَّمُوا
                  وَآثَارَهُمْ وَكُلَّ شَيْءٍ أَحْصَيْنَاهُ فِي إِمَامٍ مُبِينٍ
                  ۩{" "}
                </p>
                <p>
                  {" "}
                  وَقُوَّتِهَا أَلْفَ أَلْفِ لَا حَوْلَ ، وَلَا قُوَّةَ إلَّا
                  بِاَللَّهِ الْعُلَى الْعَظِيم ۩{" "}
                </p>
                <p>
                  {" "}
                  بِسْمِ اللَّهِ أَذًى لَا يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِى
                  الأَرْضِ ، وَلَا السَّمَاءَ ، وَهُوَ السَّمِيعُ الْعَلِيمُ ۩{" "}
                </p>
                <p>
                  {" "}
                  أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ
                  ۩{" "}
                </p>
                <p>
                  {" "}
                  بِسْمِ اللَّهِ الْخَالِقُ الْأَكْبَر ، وَهُو حِرْز مَانِع
                  مِمَّا نَخَاف ، ونحذره لَا قُدْرَةَ لِمَخْلُوق مَعَ قُدْرَةٍ
                  الْخَالِقِ الجمهُ بِلِجَام قُدْرَتِه ، وَكَانَ اللَّهُ قَوِيّا
                  عَزِيزًا حُمّ عسق حمايتنا ۩{" "}
                </p>
                <p> كهيعص كفايتنا ۩ </p>
                <p>
                  {" "}
                  فَسَيَكْفِيكَهُمُ اللَّهُ وَهُوَ السَّمِيعُ الْعَلِيمُ ۩{" "}
                </p>
                <p>
                  {" "}
                  سَتْر الْعَرْش مَسْبُول عَلَيْنَا ، وَعَيْنُ اللَّهِ نَاظِرُه
                  إلَيْنَا ۩{" "}
                </p>
                <p>
                  {" "}
                  بِحَوْلِ اللَّهِ لَا يَقْدِرُو عَلَيْنَا ، وَاَللّهُ مِنْ ،
                  وَرَائِهِم مُحِيط بَلْ هُوَ قُرْآنٌ مَجِيدٌ فِى لَوْحٍ
                  مَحْفُوظٍ . ۩{" "}
                </p>
                <hr />
              </div>
            </div>
          </div> */}
        </div>
      </Slider>
    </div>
  );
}

// ---------------------------------------------------------------------------------------------------------------------
